export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  ADVANCED_ASSIGNMENT: 'advanced_assignment',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CUSTOM_ROLES: 'custom_roles',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TIKTOK: 'channel_tiktok',
  CHANNEL_VOICE: 'channel_voice',
  KANBAN_BOARD: 'kanban_board',
  CONTACT_CHATWOOT_SUPPORT_TEAM: 'contact_chatwoot_support_team',
  CAPTAIN_CUSTOM_TOOLS: 'custom_tools',
  CAPTAIN_V2: 'captain_integration_v2',
  CAPTAIN_TASKS: 'captain_tasks',
  CAPTAIN_DOCUMENT_AUTO_SYNC: 'captain_document_auto_sync',
  SAML: 'saml',
  COMPANIES: 'companies',
  ADVANCED_SEARCH: 'advanced_search',
  CONVERSATION_REQUIRED_ATTRIBUTES: 'conversation_required_attributes',
  SCHEDULE_MESSAGES: 'schedule_messages',
  EMAIL_SEQUENCES: 'email_sequences',
  WHATSAPP_GROUPS: 'whatsapp_groups',
  AI_AGENT: 'ai_agent',
  VOIP_CALLS: 'voip_calls',
  LEAD_SCORING: 'lead_scoring',
  CONVERSATION_UNREAD_COUNTS: 'conversation_unread_counts',
  CONTACT_IDENTITIES: 'contact_identities',
  IMOVEIS_SUGGESTION: 'imoveis_suggestion',
  AGENDA_CENTRAL: 'agenda_central',
  JORNADA_360: 'jornada_360',
  LEAD_CONTEXT_PANEL: 'lead_context_panel',
  LEAD_CONTEXT_HERMES: 'lead_context_hermes',
  REAL_ESTATE_MODULE: 'real_estate_module',
  CONVERSATION_HEADER_V3: 'conversation_header_v3',
  AI_ACTION_CENTER: 'ai_action_center',
  AI_CENTER_KANBAN: 'ai_center_kanban',
  AI_CENTER_SOCIAL: 'ai_center_social',
  AI_CENTER_OPPORTUNITIES: 'ai_center_opportunities',
  AI_CENTER_CONVERSIONS: 'ai_center_conversions',
  AI_CENTER_COPILOT: 'ai_center_copilot',
  AI_CENTER_CALLS: 'ai_center_calls',
};

// Regra "qualquer uma" (helper/featureFlagRule): a conta pode ter só a V2
// (captain_integration_v2), e as telas do Captain servem às duas versões.
export const CAPTAIN_ANY_FLAG = Object.freeze({
  any: Object.freeze([FEATURE_FLAGS.CAPTAIN, FEATURE_FLAGS.CAPTAIN_V2]),
});

export const PREMIUM_FEATURES = [
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.CAPTAIN,
  FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.HELP_CENTER,
  FEATURE_FLAGS.SAML,
  FEATURE_FLAGS.CONVERSATION_REQUIRED_ATTRIBUTES,
  FEATURE_FLAGS.ADVANCED_ASSIGNMENT,
];
